export const FONTS = {
    hero: 'Unbounded, cursive',
    main: 'Montserrat, sans-serif'

}